import React, { useState, useEffect, useRef } from 'react'

import FlyUpModal from '../FlyUpModal';
import ModalOverlay from '../ModalOverlay';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import './VideoCarouselModal.css'
import CarouselIndicator from './CarouselIndicator.jsx'
import { CarouselData } from './CarouselData.js'
import { CarouselPopUpHotSpotClicked } from '../../../../utils/Analytics.js';

const isMobile = isMobileDevice();
const closeIcon = 'https://cdn.obsess-vr.com/vacheron/vac_xicon_white.svg';
const playIcon = 'https://cdn.obsess-vr.com/dyson/card-play-icon.png';
const nextArrowUrl = "https://cdn.obsessvr.com/dyson/Chevron-R.png";
const rightArrow = 'https://cdn.obsess-vr.com/vacheron/ARROW_Right.svg'
const leftArrow = 'https://cdn.obsess-vr.com/vacheron/ARROW_Legt.svg'
const swipeThreshold = 60;

const VideoCarouselModal = ({ playInsceneVideo, onModalHidden }) => {
    const vidRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentVideo, setCurrentVideo] = useState(CarouselData[0])
    const [isPlaying, setIsPlaying] = useState(false);
    const [startPos, setStartPos] = useState(0);
    const [endPos, setEndPos] = useState(0);
    const [isUserMoving, setIsUserMoving] = useState(false);
    const [isUserInteracting, setIsUserInteracting] = useState(false);
    const totalItems = CarouselData.length;
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);
    const [carouselWidth, setCarouselWidth] = useState();

    const carouselContainer = useRef();

    useEffect(() => {
        if (CarouselData.length > 0) {
            CarouselPopUpHotSpotClicked(CarouselData[0].title)
        }
    }, [])

    useEffect(() => {
        setIsPlaying(false)
        setCurrentVideo(CarouselData[currentIndex])
    }, [currentIndex])

    useEffect(() => {
        if (carouselContainer.current && carouselContainer.current.clientWidth)
            setCarouselWidth(carouselContainer.current.clientWidth);
    }, [carouselContainer.current]);

    const toggleVideo = () => {
        if (isPlaying) {
            vidRef.current.pause();
        } else {
            vidRef.current.play();
        }
        setIsPlaying(!isPlaying)
    }

    const onLeftArrowClick = () => {
        if (currentIndex !== 0) {
            setCurrentIndex(currentIndex - 1);
        }
    }

    const onRightArrowClick = () => {
        if (currentIndex !== totalItems - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    }

    const mediaRender = () => {
        const videoUrl = currentVideo.videoUrl
        if (currentVideo.slideType == 'video') {
            return (
                <div className='video-text-modal-subtitle-container'>
                    {
                        !isPlaying ? <img className="playIcon" src={playIcon} onClick={toggleVideo} /> : <span className="pauseIcon" onClick={toggleVideo}></span>
                    }
                    <video
                        preload='metadata'
                        playsInline
                        width='100%'
                        src={currentVideo.videoUrl}
                        ref={vidRef}
                    //poster={currentVideo.imgUrl}
                    >
                    </video>
                </div>
            );
        } else if (currentVideo.slideType == 'image') {
            return (
                <div className='video-text-modal-subtitle-container'>
                    <img src={currentVideo.imgUrl} style={{ width: '100%' }} />
                </div>
            );
        } else {
            return (<></>);
        }

    }

    const titleRender = () => {
        return (
            <div className='video-text-modal-title-container'>
                <span
                    style={{
                        fontSize: '24px',
                        fontFamily: 'PreloCondensed Light',
                    }}>
                    {currentVideo.title}
                </span>
            </div>
        );
    }

    const textContainer = () => {
        return (
            <div className={currentVideo.slideType == 'text' ? 'video-text-modal-text-container  text-frame' : 'video-text-modal-text-container'}>
                <pre
                    style={{
                        fontSize: '16px',
                        fontFamily: 'Prelo-Light',
                        whiteSpace: 'pre-wrap',
                        color: '#000000'
                    }}
                >
                    {currentVideo.description}
                </pre>
                {currentVideo.slideType === 'text' && arrowIndicatore()}
            </div>
        )
    }


    const onclickHandler = (arrowType) => {
        if (arrowType == 'left-arrows') {
            setCurrentIndex(currentIndex - 1);
        } else {
            setCurrentIndex(currentIndex + 1);
        }
    }

    const arrowIndicatore = () => {
        return (
            <div className='text-modal-arrow'>
                {currentIndex > 0 && <div className="left-arrow" onClick={() => onclickHandler('left-arrow')}><img src={leftArrow} alt='left-arrow' /></div>}
                {totalItems > 1 && (currentIndex + 1) < totalItems && <div className="right-arrow" onClick={() => onclickHandler('right-arrow')}><img src={rightArrow} alt='right-arrow' /></div>}
            </div>
        )
    }

    const getSign = (num) => Math.sign(num);

    const withinBounds = (index, min, max) => (index < min || index + 1 > max) ? false : true;

    const onMouseDown = (e) => {
        e.preventDefault();
        setStartPos(e.clientX);
        setStartTime(Date.now())
        setIsUserMoving(true);
    }

    const onMouseMove = (e) => {
        e.preventDefault();
        if (isUserMoving && !isUserInteracting) {
            setEndPos(e.clientX);
            setEndTime(Date.now());
        }
    }

    const onMouseUp = (e) => {
        e.preventDefault();
        const dist = startPos - endPos;
        const isUserSwiping = Math.abs(startTime - endTime) < swipeThreshold ? true : false;
        if ((Math.abs(dist) > (carouselWidth * 0.4) || isUserSwiping) && endPos) {
            if (withinBounds(currentIndex + (getSign(dist) * 1), 0, totalItems)) {
                setCurrentIndex(currentIndex + (getSign(dist) * 1));
            }
        }

        setStartPos(0);
        setEndPos(0);
        setIsUserMoving(false);
    }

    const onTouchStart = (e) => {
        setStartPos(e.touches[0].pageX);
        setStartTime(Date.now())
        if (!carouselWidth) {
            setCarouselWidth((carouselContainer.current.clientWidth));
        }
    }

    const onTouchMove = (e) => {
        if (!isUserInteracting) {
            setEndPos(e.touches[0].pageX);
            setEndTime(Date.now());

            setIsUserMoving(true);
        }
    }

    const onTouchEnd = () => {
        const dist = startPos - endPos;
        const isUserSwiping = Math.abs(startTime - endTime) < swipeThreshold ? true : false;

        if ((Math.abs(dist) > (carouselWidth * 0.4) || isUserSwiping) && endPos) {
            if (withinBounds(currentIndex + (getSign(dist) * 1), 0, totalItems)) {
                setCurrentIndex(currentIndex + (getSign(dist) * 1));
            }
        }

        setStartPos(0);
        setEndPos(0);
        setIsUserMoving(false);
    }

    const renderModalContent = () => {
        return (
            <div className='video-text-modal-content'
                ref={carouselContainer}
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                style={{ textAlign: 'center' }}>
                {currentVideo.slideType !== 'text' &&
                    <div className="video-image-carousel-desktop">
                        <div id="carousel-arrow-container">
                            <img id="carousel-left-arrow" style={{ opacity: currentIndex !== 0 ? '1' : '0', width: '12px', height: '18px' }} src={leftArrow} onClick={onLeftArrowClick} />
                            <img id="carousel-right-arrow" style={{ opacity: currentIndex !== totalItems - 1 ? '1' : '0', width: '12px', height: '18px' }} src={rightArrow} onClick={onRightArrowClick} />
                        </div>
                        {mediaRender()}
                    </div>
                }
                {titleRender()}
                {textContainer()}
            </div>
        )
    }

    return (
        <FlyUpModal extraClassName="video-text-modal-container" onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded closeIconImage={closeIcon}>
            <ModalOverlay />
            {renderModalContent()}
        </FlyUpModal>
    )
}

export default VideoCarouselModal;